export default "__VITE_ASSET__74ea7eae__"